import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, Pipe, PipeTransform } from '@angular/core';

export function customFieldMatches(term: string | null | undefined, ...texts: unknown[]): boolean {
    const needle = (term ?? '').trim().toLowerCase();
    if (!needle) {
        return true;
    }
    return texts.some((text) => text !== null && text !== undefined && String(text).toLowerCase().includes(needle));
}

@Pipe({
    name: 'customFieldFilter',
    standalone: true,
})
export class CustomFieldFilterPipe implements PipeTransform
{
    transform<T>(items: T[] | null | undefined, term: string | null | undefined, nameOf: (item: T) => unknown, valueOf?: (item: T) => unknown): T[] {
        if (!items?.length || !(term ?? '').trim()) {
            return items ?? [];
        }
        return items.filter((item) => customFieldMatches(term, nameOf(item), valueOf ? valueOf(item) : null));
    }
}

@Component({
    selector: 'app-custom-field-search',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ph-input size="small"
                  type="text"
                  icon="magnifying-glass"
                  clearable
                  placeholder="Search fields"
                  aria-label="Search custom fields"
                  [value]="term"
                  (input)="onInput($event)"
                  (keydown.enter)="$event.preventDefault()"
                  (ph-clear)="setTerm('')"></ph-input>
    `,
    styles: [':host { display: block; width: 14rem; max-width: 100%; }'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomFieldSearchComponent
{
    @Input() term = '';
    @Output() termChange = new EventEmitter<string>();

    onInput(event: Event): void {
        event.stopPropagation();
        this.setTerm((event.composedPath()[0] as HTMLInputElement)?.value ?? '');
    }

    setTerm(term: string): void {
        if (term === this.term) {
            return;
        }
        this.term = term;
        this.termChange.emit(term);
    }
}
